import React from 'react';
import tracer from '../../../utilities/trace';

// lifted from react-use temporarily - they need to fix a typescript version issue causing build errors

export default function useLocalStorage<T>(key: string, initialValue?: T, raw?: boolean): [T, (value: T) => void, () => void] {
    const [state, setState] = React.useState<T>(() => {
        try {
            const localStorageValue = localStorage.getItem(key);
            if (typeof localStorageValue !== 'string') {
                localStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue));
                return initialValue;
            }
            return raw ? localStorageValue : JSON.parse(localStorageValue || 'null');
        } catch {
            // If user is in private mode or has storage restriction
            // localStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    });

    React.useEffect(() => {
        try {
            const serializedState = raw ? String(state) : JSON.stringify(state);
            tracer.info(`Updating ${key} to ${serializedState}`);
            localStorage.setItem(key, serializedState);
        } catch {
            // If user is in private mode or has storage restriction
            // localStorage can throw. Also JSON.stringify can throw.
        }
    }, [key, raw, state]);

    function clear() {
        localStorage.removeItem(key);
    }

    return [state, setState, clear];
}
